export default __webpack_public_path__ + "static/media/portl-logo-black.d401d4e4.png";